import { fetchDiff as fetchDiffApi } from 'support/api/VideoApi';
import { HttpClient } from 'support/api/api-types';
import { KitcenSinkRow, KitchenSinkRowItem, VideoCtvRedux } from 'store-types';
import { AppDispatch } from 'app-types';
import { fetchKitchenSinkRows, fetchKitchenSink } from 'actions/kitchenSink';
import { isRowWithScoring } from 'support/rowHelper';
import { fetchScoring } from './scoring';

type RowWithIdAndToken = { id: string; token?: string | null } & (KitcenSinkRow | KitchenSinkRowItem | Record<string, unknown>);

export const DIFF = 'DIFF' as const;
export const CLEAR_DIFF = 'CLEAR_DIFF' as const;

export const clearDiff = () => ({
  type: CLEAR_DIFF,
});

const findRowsToUpdate = (array1: RowWithIdAndToken[], array2: KitcenSinkRow[] | null) => {
  const rowsToUpdate: string[] = [];
  let updateScoring = false;

  array1.forEach(item1 => {
    const matchingItem = (array2 ?? []).find(item2 => item2.id === item1.id);
    if (matchingItem && item1.token !== matchingItem.token) {
      rowsToUpdate.push(item1.id);
      if (isRowWithScoring(matchingItem)) {
        updateScoring = true;
      }
    }
  });
  return { rowsToUpdate, updateScoring };
};

export const fetchDiff = (diffMenuId: string | number) => async (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const {
    rows: prevRows,
    dataToken: prevDataToken,
    fullRefreshToken: prevFullRefreshToken,
  } = getState().diff.data || {};
  const KSRows = getState().kitchenSink.data?.order;
  const KSHero = getState().kitchenSink.data?.hero?.properties;
  const KSRowsAndHero = KSHero ? [KSHero, ...KSRows] : KSRows;
  const scoringError = getState().scoring.error;

  try {
    const diffResponse = await dispatch<{
      rows: KitcenSinkRow[] | null;
      dataToken: string;
      fullRefreshToken: string;
    }>({
      type: DIFF,
      promise: (httpClient: HttpClient) => fetchDiffApi(httpClient, diffMenuId),
    });
    const { rows, dataToken, fullRefreshToken } = diffResponse;

    if (scoringError) {
      dispatch(fetchScoring());
    }

    // first time
    if (!prevRows) {
      const { rowsToUpdate, updateScoring } = findRowsToUpdate(
        KSRowsAndHero,
        rows,
      );
      if (rowsToUpdate.length > 0) {
        dispatch(fetchKitchenSinkRows(rowsToUpdate));
        if (updateScoring) dispatch(fetchScoring());
      }
    } else if (fullRefreshToken !== prevFullRefreshToken) {
      dispatch(fetchKitchenSink());
      dispatch(clearDiff());
      dispatch(fetchScoring());
    } else if (dataToken !== prevDataToken) {
      const { rowsToUpdate, updateScoring } = findRowsToUpdate(prevRows, rows);
      if (rowsToUpdate.length > 0) {
        dispatch(fetchKitchenSinkRows(rowsToUpdate));
        if (updateScoring) dispatch(fetchScoring());
      }
    }
  } catch {
    // no-op
  }
};
